<p class="text-center blue-dark font-8px mb-xs-sm-60">
  ©️ 2000-{{year}}, Powered by Univeris<br />
  <span class="spanVersion generalBackground">{{ version }}</span>
</p>
